import { CheckIn, DeviceId, UtcTime } from 'shared/models';

export const Actions = {
    GET_CHECKINS_REQUEST: 'GET_CHECKINS_REQUEST',
    GET_CHECKINS_SUCCESS: 'GET_CHECKINS_SUCCESS',
    GET_CHECKINS_FAILURE: 'GET_CHECKINS_FAILURE',
};

export const getCheckInsRequest = (deviceId: DeviceId, meta?: { since?: UtcTime }) => ({
    type: Actions.GET_CHECKINS_REQUEST,
    payload: deviceId,
    meta,
});
export const getCheckInsSuccess = (checkIns: CheckIn[], meta: { deviceId: DeviceId }) => ({
    type: Actions.GET_CHECKINS_SUCCESS,
    payload: checkIns,
    meta,
});
export const getCheckInsFailure = (err: Error, meta: { deviceId: DeviceId }) => ({
    type: Actions.GET_CHECKINS_FAILURE,
    payload: err,
    error: true,
    meta,
});
